import { render, staticRenderFns } from "./AchievementsSelect.vue?vue&type=template&id=d8e36c22"
import script from "./AchievementsSelect.vue?vue&type=script&lang=ts"
export * from "./AchievementsSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports